module.exports = __webpack_public_path__ + "main/images/shared/listen-articles.68587de8b55ba06f2e346163bd068f85.png";